import { Observable } from 'rxjs';

import { GraphSchema } from '@camelot/server';

export enum DateTimeKind {
  Unknown = 0,
  DateTime = 1,
  Date = 2,
  TimeSpan = 3,
}
type KeyValuePair = {
  key: string;
  value: number;
};
export enum ParameterType {
  Unknown,
  String,
  Number,
  Boolean,
  DateTime,
  Guid,
  Enum,
  TimeStamp,
  Currency,
  Percentage,
  AsyncEnum,
}

export interface GridEnumInfo {
  cellRenderer: any;
  enum: any;
  labelFn: (value: number) => string;
}

export interface GridAsyncEnumInfo {
  values$: Observable<{ id: string; name: string }[]>;
  numericId?: boolean;
}

export interface GridMetaData {
  name: string;
  type: ParameterType;
  asyncEnumInfo?: GridAsyncEnumInfo;
  enumInfo?: GridEnumInfo;
  enumName?: 'Criticity' | string;
  isCollection?: boolean;
  isSortable?: boolean;
  nullable?: boolean;
  multiSearchEnabled?: boolean;
  meSearchEnabled?: boolean;
  shownByDefault?: boolean;
  showEntireListWhenFiltering?: boolean;
  additionalInfo?: KeyValuePair[];
  dateTimeKind?: DateTimeKind;
  highlight?: boolean;
  uniqueIdentifier?: boolean;
  _front?: boolean;
}

export const gridMetaDataProps = new GraphSchema<GridMetaData>([
  'name',
  'type',
  'isCollection',
  'isSortable',
  'nullable',
  'shownByDefault',
  'additionalInfo',
  'enumName',
  'meSearchEnabled',
  'multiSearchEnabled',
  'showEntireListWhenFiltering',
  'dateTimeKind',
]);
